import AttendeeType from 'owa-service/lib/contract/AttendeeType';
import { convertRecipientsToAttendees } from 'owa-calendar-notes-editor/lib/utils/recipientAttendeeConversions';
import { getRecipientsFromRequiredAttendees } from 'owa-calendar-compose-form-store/lib/utils/getRecipientsFromAttendees';
import { orchestrator } from 'satcheljs';
import {
    removePersonaFromRequiredAttendees,
    updateRequiredAttendees,
} from 'owa-calendar-compose-form-actions';

export default orchestrator(removePersonaFromRequiredAttendees, actionMessage => {
    let recipients = getRecipientsFromRequiredAttendees();
    for (let index = 0; index < recipients.length; index++) {
        if (actionMessage.persona === recipients[index].persona) {
            recipients.splice(index, 1);
            break;
        }
    }
    const attendees: AttendeeType[] = convertRecipientsToAttendees(recipients);
    updateRequiredAttendees(attendees);
});
